import { palette } from '../palette';

export const MuiBreadcrumbs = {
  defaultProps: {
    separator: '>',
  },
  styleOverrides: {
    root: {
      '& .MuiBreadcrumbs-separator': {
        color: palette.custom.gray[300],
      },
      '& .MuiBreadcrumbs-li:last-child, & .MuiBreadcrumbs-li:last-child .MuiTypography-root': {
        color: palette.primary[700], 
        fontWeight: 600, 
      },
      '& a': {
        color: palette.custom.gray[600], // Text black only within breadcrumbs
        textDecoration: 'none',
        fontWeight: 400, // Light font weight for links
        '&:hover': {
          textDecoration: 'underline',
          fontWeight: 500,
        },
      },
    },
  },
};